import defaultClient from '@src/api/clients/default';

const URL = (path = '') => `app1/prospects/${path}`;

// Public (no auth) — used by GetStartedPage
export function fetchProspectVerticals() {
  return defaultClient.request({
    url: URL('verticals/'),
    method: 'GET',
    auth: false,
  });
}

export function fetchProspectEstimate(payload = {}) {
  return defaultClient.request({
    url: URL('estimate/'),
    method: 'POST',
    payload,
    auth: false,
  });
}

export function fetchProspectZipDemographics(payload = {}) {
  return defaultClient.request({
    url: URL('zip-demographics/'),
    method: 'POST',
    payload,
    auth: false,
  });
}

export function submitProspect(payload = {}) {
  return defaultClient.request({
    url: URL('submit/'),
    method: 'POST',
    payload,
    auth: false,
  });
}

// Staff-only
export function listProspects(params = {}) {
  const query = new URLSearchParams();
  if (params.status) query.set('status', params.status);
  if (params.search) query.set('search', params.search);
  const qs = query.toString();
  return defaultClient.request({
    url: URL(qs ? `?${qs}` : ''),
    method: 'GET',
  });
}

export function fetchProspect(token) {
  return defaultClient.request({
    url: URL(`${token}/`),
    method: 'GET',
  });
}

export function updateProspect(token, payload = {}) {
  return defaultClient.request({
    url: URL(`${token}/`),
    method: 'PATCH',
    payload,
  });
}

export function fetchProspectFitReport(token) {
  return defaultClient.request({
    url: URL(`${token}/fit-report/`),
    method: 'GET',
  });
}

export function shareProspectProjections(token) {
  return defaultClient.request({
    url: URL(`${token}/share-projections/`),
    method: 'POST',
  });
}

export function acceptProspect(token) {
  return defaultClient.request({
    url: URL(`${token}/accept/`),
    method: 'POST',
  });
}

export function declineProspect(token, reason) {
  return defaultClient.request({
    url: URL(`${token}/decline/`),
    method: 'POST',
    payload: { reason },
  });
}

export function archiveProspect(token) {
  return defaultClient.request({
    url: URL(`${token}/`),
    method: 'PATCH',
    payload: { is_archived: true },
  });
}

export function convertProspect(token) {
  return defaultClient.request({
    url: URL(`${token}/convert/`),
    method: 'POST',
  });
}

export function convertProspectGroup(groupToken) {
  return defaultClient.request({
    url: URL(`group/${groupToken}/convert-all/`),
    method: 'POST',
  });
}
